import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedUiTableModule} from '@snelstart/ui-table';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {DomainLogicModule} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiIconModule} from "@snelstart/ui-icon";
import {SharedUiTooltipModule} from "@snelstart/ui-tooltip";
import {SharedUiBadgeModule} from "@snelstart/ui-badge";
import {SharedUiTagModule} from "@snelstart/ui-tag";

@NgModule({
  imports: [
    CommonModule,
    SharedUiTableModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiAlertModule,
    SharedUiDialogModule,
    DomainLogicModule,
    SharedUiIconModule,
    SharedUiTooltipModule,
    SharedUiBadgeModule,
    SharedUiTagModule,
  ],
  declarations: [],
  exports: [],
})
export class FeatureTaxTasksListModule {}
